var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-input',_vm._b({staticClass:"core-search",attrs:{"dense":"","label":_vm.label,"labelIcon":['far', 'search']},model:{value:(_vm.q),callback:function ($$v) {_vm.q=$$v},expression:"q"}},'core-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }